/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const navItemLinkStyle = {
  navItemLink: (theme: Theme) => ({
    padding: "1rem 0",
    margin: 0,
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    cursor: "pointer",
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      height: "100%",
      cursor: "pointer",
      paddingInline: "1rem",
      border: "none",
      backgroundColor: "transparent",
      transition: "background-color 50ms ease-in-out",
    },
  }),
  active: (theme: Theme) => ({
    [theme.breakpoints.up("lg")]: {
      "&::before": {
        content: "''",
        position: "absolute",
        bottom: 0,
        left: "1rem",
        height: "0.25rem",
        width: "calc(100% - 2rem)", // 2rem because of paddingInline in navItemLink on desktop
        backgroundColor: theme.palette.secondary.main,
      },
    },
  }),
};
